/* @flow */

import React from 'react';
import styled from '@emotion/styled';
import { padding } from 'polished';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  onClick: Function
};

const Button = styled.span(({ theme }) => ({
  alignItems: 'center',
  color: theme.color.panelAccent,
  display: 'flex',
  ...padding('0', 10)
}));

function InfoButton({ onClick }: Props) {
  return (
    <Tappable component={Button} onTap={onClick} stopPropagation>
      <span className="ion-information-circled" />
    </Tappable>
  );
}

export default InfoButton;
